import type { Address, Card } from '../cards.types';

export const DEMO_HOLDER_NAME = 'John Doe';

export const demoBillingAddress: Address = {
  street: '25 Old Broad Street',
  building: 'Floor 12',
  postCode: 'EC2N 1HN',
  city: 'London',
  state: 'Greater London',
  country: 'United Kingdom',
};

const baseCard = {
  colour: 'grey',
  expiryMonth: 1,
  expiryYear: 2027,
  holderName: DEMO_HOLDER_NAME,
  monthlyLimit: 25000,
  monthlySpent: 10998,
  lastActivityAt: '2025-07-24T03:12:00Z',
  createdAt: '2024-08-12T09:00:00Z',
  balanceOnCard: 20,
  billingAddress: demoBillingAddress,
  expectedDelivery: null,
} satisfies Partial<Card>;

export const cardsFixture: Card[] = [
  {
    ...baseCard,
    id: 'card-eur-main-9374',
    name: 'EUR Main',
    type: 'virtual',
    status: 'active',
    currency: 'EUR',
    number: '4539742462859374',
    last4: '9374',
    cvv: '318',
    assignedTo: 'Nick Brown',
    linkedAccountId: 'acc-eur-main',
  },
  {
    ...baseCard,
    id: 'card-eur-taxes-2364',
    name: 'EUR Taxes',
    type: 'virtual',
    status: 'active',
    colour: 'green',
    currency: 'EUR',
    number: '4539187340952364',
    last4: '2364',
    cvv: '742',
    assignedTo: 'John Doe',
    linkedAccountId: 'acc-eur-taxes',
    monthlySpent: 3120,
  },
  {
    ...baseCard,
    id: 'card-eur-main-5313',
    name: 'EUR Main',
    type: 'virtual',
    status: 'ordered',
    colour: 'violet',
    currency: 'EUR',
    number: '4539420872265313',
    last4: '5313',
    cvv: '905',
    holderName: 'Marina Alasania',
    assignedTo: 'Marina Alasania',
    linkedAccountId: 'acc-eur-main',
    monthlySpent: 0,
    lastActivityAt: null,
    createdAt: '2025-07-24T03:12:00Z',
  },
  {
    ...baseCard,
    id: 'card-eur-business-8829',
    name: 'EUR Business',
    type: 'physical',
    status: 'active',
    colour: 'rose',
    currency: 'EUR',
    number: '4539699304308829',
    last4: '8829',
    cvv: '164',
    holderName: 'Maximilian Dwayn',
    assignedTo: 'Maximilian Dwayn',
    linkedAccountId: 'acc-eur-taxes',
    monthlySpent: 18400,
  },
  {
    ...baseCard,
    id: 'card-eur-business-7710',
    name: 'EUR Business',
    type: 'physical',
    status: 'delivered',
    colour: 'orange',
    currency: 'EUR',
    number: '4539610690697710',
    last4: '7710',
    cvv: '527',
    holderName: 'Maximilian Dwayn',
    assignedTo: 'Maximilian Dwayn',
    linkedAccountId: 'acc-eur-main',
    monthlySpent: 0,
    lastActivityAt: null,
    createdAt: '2025-07-20T10:00:00Z',
    expectedDelivery: '2026-02-01',
  },
  {
    ...baseCard,
    id: 'card-eur-marketing-4410',
    name: 'EUR Marketing',
    type: 'physical',
    status: 'being_delivered',
    colour: 'blue',
    currency: 'EUR',
    number: '4539349363694410',
    last4: '4410',
    cvv: '683',
    holderName: 'John Brown',
    assignedTo: 'John Brown',
    linkedAccountId: 'acc-eur-main',
    monthlySpent: 0,
    lastActivityAt: null,
    createdAt: '2025-07-22T08:30:00Z',
    expectedDelivery: '2026-01-28',
  },
  {
    ...baseCard,
    id: 'card-usd-main-0023',
    name: 'USD Personal',
    type: 'physical',
    status: 'active',
    colour: 'black',
    currency: 'USD',
    number: '4539001957160023',
    last4: '0023',
    cvv: '291',
    expiryMonth: 8,
    expiryYear: 2026,
    holderName: 'Maryna Alasania',
    assignedTo: 'Maryna Alasania',
    linkedAccountId: 'acc-usd-main',
    monthlySpent: 6210,
  },
  {
    ...baseCard,
    id: 'card-usd-main-1180',
    name: 'USD Main',
    type: 'virtual',
    status: 'deactivated',
    colour: 'red',
    currency: 'USD',
    number: '4539093579991180',
    last4: '1180',
    cvv: '436',
    holderName: 'Patrick Colt',
    assignedTo: 'Patrick Colt',
    linkedAccountId: 'acc-usd-main',
    monthlySpent: 0,
    balanceOnCard: 0,
  },
  {
    ...baseCard,
    id: 'card-gbp-main-6671',
    name: 'GBP Main',
    type: 'physical',
    status: 'blocked',
    colour: 'grey',
    currency: 'GBP',
    number: '4539528412286671',
    last4: '6671',
    cvv: '850',
    holderName: 'Charlotte Williams',
    assignedTo: 'Charlotte Williams',
    linkedAccountId: 'acc-gbp-main',
    monthlySpent: 940,
  },
];
